import { render, staticRenderFns } from "./ObtainedLicenseCreate.vue?vue&type=template&id=c1321eec&"
import script from "./ObtainedLicenseCreate.vue?vue&type=script&lang=js&"
export * from "./ObtainedLicenseCreate.vue?vue&type=script&lang=js&"
import style0 from "./ObtainedLicenseCreate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports